// removed by extract-text-webpack-plugin
module.exports = {"component":"_ShqnVIDG-uhUWfrJ3vdE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/AskAddress/askAddress.css
// module id = 1231
// module chunks = 2